import React, { useRef, useState } from 'react';
import SmallDropdownArrow from 'components/atoms/icons/dropdownSelectArrow';
import BaseDropdown from 'components/atoms/base-dropdown';
import classNames from 'classnames';

import s from './styles.module.scss';
import HeaderLargeLinks from './large';
import HeaderSmallLinks from './small';

import type { IDropdownLinks } from '../../types';
import type { IBaseDropdownProps } from 'components/atoms/base-dropdown';

interface IProps {
  data: IDropdownLinks;
}

const HeaderDropdownLinks: React.FC<IProps> = (props) => {
  const { data } = props;
  const ref = useRef<HTMLLIElement>(null);
  const [opened, setOpened] = useState(false);
  const hasManyLinks = data.links.length > 1;

  const handleClose = () => {
    if (ref.current) {
      ref.current.click();
    }
  };

  const hasNonEmptyLinkGroup =
    data.links && data.links.some((linkGroup) => linkGroup.length > 0);

  const LinkComponent = hasManyLinks ? (
    <HeaderLargeLinks
      data={data}
      opened={opened}
      onClick={() => setOpened(false)}
    />
  ) : (
    <HeaderSmallLinks data={data} onClick={handleClose} />
  );

  const offset: IBaseDropdownProps['offset'] = hasManyLinks
    ? undefined
    : [-10, -10];

  return (
    <>
      {hasNonEmptyLinkGroup && (
        <BaseDropdown
          open={opened}
          offset={offset}
          content={LinkComponent}
          onOpenChange={setOpened}
          transitionName=""
          zIndex={1011}
        >
          <li ref={ref} className={s.link} data-cy={data.dataCy}>
            <span className={s.name}>
              {data.showBadge && <i className={s.badge} />}
              {data.label}
              <SmallDropdownArrow
                className={classNames(s.icon, {
                  [s.opened]: opened,
                })}
              />
            </span>
          </li>
        </BaseDropdown>
      )}
    </>
  );
};

export default HeaderDropdownLinks;
